import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import teamData from "../data/teamData";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function TeamSection() {
    const { t } = useTranslation();
    useScrollAnimation();

    const showData = teamData.slice(0, 3).map((el, index) =>
        <div key={index} className="w-100 js-scroll fade-top w-[32%] shadow-[0px_0px_10px_#00000017] rounded-[8px]">
            <div className="w-full h-[300px]">
                <img className="w-[100%] h-[100%] border-b-[3px] border-[#017e89] rounded-t-[8px]" src={el.image} alt="" />
            </div>
            <div className="p-[20px] flex flex-col justify-between gap-[25px]">
                <div>
                    <div className="font-bold text-[#017E89] text-[20px] capitalize">{t(`${el.name}`)}</div>
                    <div className="capitalize">{t(`${el.posation}`)}</div>
                </div>
                <Link
                    to={`/teamDetails/${el.id}`}>
                    <span className="capitalize font-bold">{t("view profile")}</span>
                    <img className="h-auto" src={require("../../assets/icons/twoLines.svg").default} alt="" />
                </Link>
            </div>
        </div>
    )
    return (
        <section className="relative py-[40px]">
            <div className="flex flex-col items-center justify-center mx-auto w-fit">
                <div className="js-scroll fade-top w-[90px] h-[30px]">
                    <img className="w-[100%] h-[100%]" src={require("../../assets/icons/lineMainTitle.svg").default} alt="" />
                </div>
                <div className="js-scroll fade-btm text-[35px] font-bold uppercase text-[#017E89]">{t("Our Team")}</div>
                <span className="js-scroll fade-btm w-[50%] bg-[#017E89] h-[3px]"></span>
            </div>
            <div className="container flex flex-col gap-[15px] items-center py-[20px]">
                <div className="f-col flex justify-center flex-wrap gap-[20px]">
                    {showData}
                </div>
                <Link className="js-scroll fade-btm bg-[#017E89] w-fit px-[30px] py-[7px] rounded-[4px] text-white font-bold capitalize" to={"/team"}>{t("Show More")}</Link>
            </div>
        </section>
    );
}